import { trackEvent as t } from '../track';
import { MetadataAppType } from './propertyTypes';

interface ManageAppsProps {
  '[Metadata] App type': MetadataAppType,
}

export const manageApps = {
  addSuccessful: (props: ManageAppsProps) => t('[Manage Apps] Add app successful', props),
  fixSuccessful: (props: ManageAppsProps) => t('[Manage Apps] Fix app successful', props),
  removeSuccessful: (props: ManageAppsProps) => t('[Manage Apps] Remove app successful', props),
  view: () => t('[Manage Apps] View'),
};
